import { ApiUserCertificationBadge, IUserBadge } from '@/types';

/**
 * Maps API user badge to frontend IUserBadge format.
 *
 * @param apiUserBadge - ApiUserCertificationBadge object from the API
 *
 * @returns IUserBadge formatted for the frontend
 */
export function mapApiUserBadgeToFrontend({
  apiUserBadge,
}: {
  apiUserBadge: ApiUserCertificationBadge;
}): IUserBadge {
  return {
    userId: apiUserBadge.user_id,
    certBadgeName: apiUserBadge.cert_badge_name,
    certBadgeId: apiUserBadge.cert_badge_id,
    certificationId: apiUserBadge.certification_id,
    certificationTitle: apiUserBadge.certification_title,
    certificationTitleShort: apiUserBadge.certification_title_short,
    scenarioId: apiUserBadge.scenario_id,
    scenarioTitle: apiUserBadge.scenario_title,
    scenarioTitleShort: apiUserBadge.scenario_title_short,
    issuingTeam: apiUserBadge.issuing_team,
    iconUrl: apiUserBadge.icon_url,
    awardedAt: apiUserBadge.awarded_at,
    evidenceSessionId: apiUserBadge.evidence_session_id,
  };
}

/**
 * Maps API user badges to frontend IUserBadge[] format.
 *
 * @param apiUserBadges - Array of ApiUserCertificationBadge objects from the API
 *
 * @returns Array of IUserBadge formatted for the frontend
 */
export function mapApiUserBadgesToFrontend({
  apiUserBadges,
}: {
  apiUserBadges: ApiUserCertificationBadge[];
}): IUserBadge[] {
  return apiUserBadges.map((apiUserBadge) => mapApiUserBadgeToFrontend({ apiUserBadge }));
}
